import { render, staticRenderFns } from "./enrollmentMajor.vue?vue&type=template&id=3673b322&scoped=true"
import script from "./enrollmentMajor.vue?vue&type=script&lang=js"
export * from "./enrollmentMajor.vue?vue&type=script&lang=js"
import style0 from "./enrollmentMajor.vue?vue&type=style&index=0&id=3673b322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3673b322",
  null
  
)

export default component.exports